import { LayoutPrincipal } from '@/components/layout';
import { AreaCosteoPantalla } from '@/pages/AreaCosteoPantalla';
import { AvanceMatrizPantalla } from '@/pages/AvanceMatrizPantalla';
import { CostosDetalladosPantalla } from '@/pages/CostosDetalladosPantalla';
import { CostosM2Pantalla } from '@/pages/CostosM2Pantalla';
import { CostosMensualesPantalla } from '@/pages/CostosMensualesPantalla';
import { MaquinariaDetalladaPantalla } from '@/pages/MaquinariaDetalladaPantalla';
import { MaquinariaGeneralPantalla } from '@/pages/MaquinariaGeneralPantalla';
import { MaquinariaPivotPantalla } from '@/pages/MaquinariaPivotPantalla';
import { MensualPantalla } from '@/pages/MensualPantalla';
import { NoEncontradoPantalla } from '@/pages/NoEncontradoPantalla';
import { PivotCostosPantalla } from '@/pages/PivotCostosPantalla';
import { ProductividadPantalla } from '@/pages/ProductividadPantalla';
import { UnidadesProduccionPantalla } from '@/pages/UnidadesProduccionPantalla';
import { VentaVsCostoPantalla } from '@/pages/VentaVsCostoPantalla';
import { ViviendaGerenciaPantalla } from '@/pages/ViviendaGerenciaPantalla';
import { Navigate, createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <LayoutPrincipal />,
      children: [
        { index: true, element: <Navigate to="/costos" replace /> },
        { path: 'costos', element: <CostosDetalladosPantalla /> },
        { path: 'costos-mensuales', element: <CostosMensualesPantalla /> },
        { path: 'pivot', element: <PivotCostosPantalla /> },
        { path: 'avance', element: <AvanceMatrizPantalla /> },
        { path: 'costos-m2', element: <CostosM2Pantalla /> },
        { path: 'avance-m2', element: <Navigate to="/avance" replace /> },
        { path: 'mensual', element: <MensualPantalla /> },
        { path: 'venta-vs-costo', element: <VentaVsCostoPantalla /> },
        { path: 'productividad', element: <ProductividadPantalla /> },
        { path: 'vivienda-gerencia', element: <ViviendaGerenciaPantalla /> },
        { path: 'area-costeo', element: <AreaCosteoPantalla /> },
        { path: 'maquinaria', element: <MaquinariaDetalladaPantalla /> },
        { path: 'maquinaria-pivot', element: <MaquinariaPivotPantalla /> },
        { path: 'maquinaria-general', element: <MaquinariaGeneralPantalla /> },
        { path: 'unidades-produccion', element: <UnidadesProduccionPantalla /> },
        { path: '*', element: <NoEncontradoPantalla /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
